import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Footer from '../components/Footer';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Paper,
} from '@mui/material';
import { FaCalendar, FaCertificate, FaHome } from 'react-icons/fa';

const ProgramDetails = () => {
  const program = useLoaderData();

  return (
    <>
      <Box maxWidth="lg" mx="auto" px={3} py={6}>
        <Card elevation={3} sx={{ p: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            {program.program}
          </Typography>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {program.title}
          </Typography>
          <Typography variant="body1" mt={2}>
            {program.info}
          </Typography>

          {program.pricing &&
            Object.entries(program.pricing).map(([key, value]) => (
              <Typography key={key} variant="body1" fontWeight="bold" mt={2}>
                {key.replace(/_/g, ' ')}: {value} $
              </Typography>
            ))}

          <Grid container spacing={3} mt={2}>
            <Grid item xs={12} md={4}>
              <Paper elevation={1} sx={{ display: 'flex', gap: 2, p: 2 }}>
                <FaHome size={24} color="#1976d2" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">Faculty</Typography>
                  <Typography variant="body2">{program.faculty}</Typography>
                </Box>
              </Paper>
            </Grid>
            {/* <Grid item xs={12} md={4}>
              <Paper elevation={1} sx={{ display: 'flex', gap: 2, p: 2 }}>
                <FaCertificate size={24} color="#2e7d32" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">Degree</Typography>
                  <Typography variant="body2">{program.certification}</Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={1} sx={{ display: 'flex', gap: 2, p: 2 }}>
                <FaCalendar size={24} color="#6a1b9a" />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">Expected Duration</Typography>
                  <Typography variant="body2">{program.duration}</Typography>
                </Box>
              </Paper>
            </Grid> */}
          </Grid>

          <Box mt={5}>
            <Typography variant="h5" gutterBottom>Program Details</Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" gutterBottom>
                  <strong>Expected Duration:</strong> {program.duration}
                </Typography>
                <Typography variant="body2" mt={2}>
                  {program.details}
                </Typography>
                <Typography variant="subtitle1" fontWeight="bold" mt={3}>
                  Curriculum
                </Typography>
                <Typography variant="body2">{program.curriculum}</Typography>
              </Grid>
              {program.imageURL && (
                <Grid item xs={12} md={6}>
                  <CardMedia
                    component="img"
                    height="300"
                    image={program.imageURL}
                    alt={program.program}
                    sx={{ borderRadius: 2 }}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </Card>
      </Box>

      <Footer />
    </>
  );
};

export default ProgramDetails;

export const programDetailsLoader = async ({ params }) => {
  const { id, type } = params;
  const url = `/${type}Programs.json`;
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error('Could not load program data');
  }

  const data = await res.json();
  const program = data.find((p) => p.id.toString() === id);

  if (!program) {
    throw new Error('Program not found');
  }

  return program;
};
